import { render, staticRenderFns } from "./NewMessageAbsenceInfo.vue?vue&type=template&id=c80cb216&scoped=true"
import script from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
export * from "./NewMessageAbsenceInfo.vue?vue&type=script&lang=js"
import style0 from "./NewMessageAbsenceInfo.vue?vue&type=style&index=0&id=c80cb216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80cb216",
  null
  
)

export default component.exports